import React from 'react';
import { ModalComponent } from '../../../components/Modal/ModalComponent';
import { ChatbotLocalizedLabels } from '../types';

interface EndChatConfirmationProps {
  labels: ChatbotLocalizedLabels;
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const EndChatConfirmation: React.FC<EndChatConfirmationProps> = ({ labels, isOpen, onConfirm, onCancel }) => {
  const modalObject = {
    showModal: isOpen,
    dialogClass: 'chatbot-exit-modal',
    head: {
      modalTitle: labels.endChatConfirmTitle,
    },
    body: {
      confirmBoxData: {
        messagetext: labels.endChatConfirmBody,
      },
    },
    footer: {
      footerData: [
        {
          variant: 'btn btn-outline-secondary btn-cancel',
          ariaLabel: labels.endChatConfirmReturn,
          display: labels.endChatConfirmReturn,
          onSubmit: onCancel,
        },
        {
          variant: 'outline-secondary',
          ariaLabel: labels.endChatConfirmEnd,
          display: labels.endChatConfirmEnd,
          onSubmit: onConfirm,
        },
      ],
    },
    clickHandler: onCancel,
    showHeaderCloseBtn: true,
  };

  return <ModalComponent modalObject={modalObject} />;
};
